import type { AlertChannel, AlertFrequency, IAlertSettingUpdate } from '@d-orca/shared/alert-kinds';

/** A row's two change callbacks, each turned into the setting update it asks for. */
export function rowChangeHandlers(apply: (update: IAlertSettingUpdate) => void) {
  return {
    onChannelChange: (channel: AlertChannel, on: boolean) => apply({ channels: { [channel]: on } }),
    onFrequencyChange: (frequency: AlertFrequency) => apply({ frequency }),
  };
}
